<template>
  <div ref="chartContainer" style="width: 100%; height: 100%;">
    <highcharts class="mt-4" :options="options"
     ref="aChart" style="width: 100%; height: 100%;"></highcharts>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'MachineWiseUtilization',
  props: {
    thisMachines: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.chart = this.$refs.aChart.chart;
    this.createSeries();
    this.initResizeObserver();
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  data() {
    return {
      resizeObserver: null,
      chart: null,
      options: {
        chart: {
          type: 'column',
          style: {
            fontFamily: 'Poppins, sans-serif',
          },
        },
        title: {
          text: 'Machine-wise Utilization  (%)',
          style: {
            color: '',
          },
        },
        plotOptions: {
          series: {
            grouping: true,
            borderWidth: 0,
          },
        },
        legend: {
          enabled: true,
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          itemStyle: {
            color: '#333',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          shared: true,
        },
        xAxis: {
          categories: [],
          labels: {
            rotation: -45,
            style: {
              color: '',
            },
          },
        },
        yAxis: [
          {
            title: {
              text: null,
            },
            labels: {
              style: {
                color: '',
              },
            },
          },
        ],
        series: [],
      },
    };
  },
  computed: {
    ...mapState('helper', ['isDark']),
  },
  methods: {
    roundOff(val) {
      if (val || val === 0) {
        return Math.round((val + Number.EPSILON) * 100) / 100;
      }
      return 0;
    },
    createSeries() {
      const shiftColors = {
        'Shift A': '#3D519D', // Dark Blue
        'Shift B': '#1CA4D7', // Green
        'Shift C': '#5F4E94', // Amber
      };
      const dateShiftKeys = [
        ...new Set(this.thisMachines.map((m) => `${m.date} ${m.shift}`)),
      ];

      const machineNames = [
        ...new Set(this.thisMachines.map((m) => m.machinename)),
      ];

      const series = dateShiftKeys.map((key) => {
        const shift = key.split(' ').slice(-2).join(' ');
        const data = machineNames.map((machine) => {
          const entry = this.thisMachines.find((m) => m.machinename === machine && `${m.date} ${m.shift}` === key);
          return {
            name: machine,
            y: entry ? this.roundOff(entry.a) : 0,
          };
        });

        return {
          name: key,
          data,
          color: shiftColors[shift] || '#9E9E9E',
          dataLabels: {
            enabled: true,
            style: {
              color: '#000000',
              fontWeight: 'bold',
            },
          },
        };
      });

      this.options.xAxis.categories = machineNames;
      this.options.series = series;
      this.$nextTick(() => this.reflowChart());

      // Optional: enable dataLabels globally (in case it's not working per-series)
      this.options.plotOptions.series.dataLabels = {
        enabled: true,
        style: {
          color: '#000000',
          fontWeight: 'bold',
        },
      };
    },
    initResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        this.reflowChart();
      });
      if (this.$refs.chartContainer) {
        this.resizeObserver.observe(this.$refs.chartContainer);
      }
    },
    reflowChart() {
      this.$nextTick(() => {
        const chartInstance = this.$refs.aChart?.chart;
        if (chartInstance?.reflow) chartInstance.reflow();
      });
    },
  },
  watch: {
    thisMachines: {
      deep: true,
      handler() {
        this.createSeries();
      },
    },
    isDark: {
      immediate: true,
      handler(val) {
        if (val) {
          this.options.title.style.color = '#FFFFFF';
          this.options.yAxis[0].labels.style.color = '#FFFFFF';
          this.options.xAxis.labels.style.color = '#FFFFFF';
          if (this.options.series[0]) {
            this.options.series[0].color = '#21C77C';
          }
        } else {
          this.options.title.style.color = '#333333';
          this.options.yAxis[0].labels.style.color = '#666666';
          this.options.xAxis.labels.style.color = '#666666';
          if (this.options.series[0]) {
            this.options.series[0].color = '#354493';
          }
        }
      },
    },
  },
};
</script>
